export const initialValues = {
  first_name: "",
  last_name: "",
  email: "",
  phone_number: "",
  account_name: "",
  account_type: "",
};
